import React from 'react';
import './Header.css';

const Header = ({ title, leftIcon, rightIcon, onRightIconClick }) => {
  return (
    <div className="header-container">
      {leftIcon && <img src={leftIcon} alt="Left Icon" className="icon-style" />}
      <p className="header-title">{title}</p>
      {rightIcon && (
        <img
          src={rightIcon}
          alt="Right Icon"
          className="icon-style clickable"
          onClick={onRightIconClick}
        />
      )}
    </div>
  );
};

export default Header;
